/*
 * POST Controller - Easily POST data to an endpoint.
 *
 * Usage Instructions:
 * 1. Define the following within the scope of this controller:
 *    - `url`: The target endpoint for the POST request.
 *    - `successMessage` (optional): The message to display on a successful request.
 *    - `errorMessage` (optional): The message to display on a failed request.
 *    - `payload` (optional): Data to send with the POST request.
 * 
 * 2. Attach the controller's `submit` action to a button or link that will trigger the POST request.
 *
 * Check out the patient_row partial for an example app/views/teletherapy_rooms/_patient_row.html.erb
 */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    url: String,
    payload: Object,
    successMessage: String,
    errorMessage: String
  }

  submit() {
    const url = this.urlValue;
    const payload = this.hasPayloadValue ? this.payloadValue : {};
    const successMessage = this.successMessageValue || "Request succeeded!";
    const errorMessage = this.errorMessageValue || "Request failed!";

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify(payload)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(errorMessage);
        }
        return response.json();
      })
      .then(data => {
        alert(successMessage);
        console.log("Response data:", data);
      })
      .catch(error => {
        alert(errorMessage);
        console.error("Error:", error);
      });
  }
}
